import React from 'react';

import { Box } from '@material-ui/core';

import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import LandingNext from '../../Landing/Next';
// import LandingSura from '../../Landing/Sura';
// import LoginFormSura from './LoginForm';
import { useLoginForm } from '../hooks';

const LoginSura = () => {
  const { isOpenDialog, closeDialog, dialog, handleSubmit, isLoading } =
    useLoginForm();

  if (isLoading) {
    return (
      <Box display="block">
        <Loader action="Iniciando sesión" />
      </Box>
    );
  }

  return (
    <>
      <SharedDialog
        open={isOpenDialog}
        title={dialog?.title}
        content={dialog?.content}
        actions={dialog?.action}
        onClose={closeDialog}
      />
      {/* <LandingSura childrenName="LoginSura">
        <LoginFormSura handleSubmit={handleSubmit} />
      </LandingSura> */}
      <LandingNext handleSubmit={handleSubmit} />
    </>
  );
};

LoginSura.displayName = 'LoginSura';

export default LoginSura;
